import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-bottom-dark",
  "use": "arrow-bottom-dark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-bottom-dark\">\r\n<path d=\"M4.99993 12.2139L8.1778 15.4M8.1778 15.4L11.3639 12.2139M8.1778 15.4L8.1778 -2.78537e-07\" stroke=\"#434343\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol